@if (showTitle()) {
  <div class="label truncate" i18n>Dirección</div>
}
<div [ngClass]="textClass()">
  @if (address()?.line1) {
    <span class="me-1">{{ address()?.line1 }}</span>
  }
  @if (address()?.line2) {
    <span class="me-1">{{ address()?.line2 }}</span>
  }
  @if (address()?.postalCode) {
    <span class="me-1">{{ address()?.postalCode }}</span>
  }
  @if (address()?.city) {
    <span>{{ address()?.city }}</span>
  }
</div>
